import React from "react";

import { Buffer } from "safe-buffer";
import Danger from "components/Typography/Danger";
import Warning from "components/Typography/Warning";

import "moment/locale/ru";
import Moment from "react-moment";

const filenameRegexp = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;

export function createReducer(initialState, reducerMap) {
    return (state = initialState, action) => {
        const reducer = reducerMap[action.type];


        return reducer
            ? reducer(state, action.payload)
            : state;
    };
}


export function parseJSON(response) {
    return response.data;
}

export const parseImageToBase64 = (response) => {
    const image = Buffer.from(response.data, 'binary').toString('base64');
    return `data:${response.headers['content-type'].toLowerCase()};base64,${image}`;
};

export const unixTimeToPickerString = (timestamp) => {
    const date = new Date(timestamp * 1000);
    const year = date.getFullYear();
    const month = date.getMonth();
    const day = date.getDate();
    return `${year}-${month < 10 ? "0" : ""}${month + 1}-${day < 10 ? "0" : ""}${day}`
};

export const dataURLtoFile = (dataurl, filename="file") => {
    let arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n),
        ext = mime.split("/")[1];
    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename+"."+ext, {type:mime});
};

export const getErrorFromCode = (code) => {
    let response = "";
    code = code ? code.toString() : "";
    const errors = {
        0: "Нет ошибки",
        1: "ошибка насоса",
        2: "ошибка модема",
        4: "ошибка SD-карты",
        6: "ошибка монетоприемника",
        7: "ошибка купюроприемника",
        8: "ошибка ККТ",
    };
    for (let i=0; i<code.length; ++i){
        if (!errors.hasOwnProperty(code[i])){
            response+="неизвестный тип ошибки";
        } else {
            response+=errors[parseInt(code[i],10)];
        }
        if (i !== code.length - 1) {
            response+=", "
        }
    }
    if (code !== "0"){
        return (<Danger>{response}</Danger>)
    } else {
        return (<span>{response}</span>)
    }
};

export const getLastOrderFromTime = (time) => {
    if (!time) {
        return null
    }
    const current_time_stamp = new Date().getTime() / 1000;
    const time_stamp = new Date(time).getTime() / 1000;
    if (time_stamp < current_time_stamp - 3 * 60 * 60) {
        return <Danger>
            <Moment fromNow locale="ru">{time}</Moment>
        </Danger>
    } else { if (time_stamp < current_time_stamp - 30 * 60){
        return <Warning>
            <Moment fromNow locale="ru">{ time }</Moment>
        </Warning>
    } else {
        return <Moment fromNow locale="ru">{ time }</Moment>
    }}
};

export const getWaterFromNumber = (water_amount) => {
    water_amount = parseInt(water_amount, 10);
    if (water_amount === 0) {
        return <Danger>Воды нет</Danger>
    } else if (water_amount === 1) {
        return <Warning>Воды мало</Warning>
    } else if (water_amount === 3) {
        return <span>Воды нормально</span>
    } else if (water_amount === 7) {
        return <span>Полный бак</span>
    } else {
        return <span>Неверный статус</span>
    }
};

export const openInNewTab = (path, params) => {
    params && Object.entries(params).map((prop, key) => {
        if (path[1]) {
            path = path.concat(`${key === 0 ? "?": "&"}${prop[0].toString()}=${prop[1].toString()}`);
        }
        return null;
    });
    window.open(path,"_blank");
};

export const getFilenameFromContentDisposition = (contentDisposition) => (
    decodeURIComponent(filenameRegexp.exec(contentDisposition)[1])
);

export const getMonthFromNum = num => (
    typeof num === "number" ?
        ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"][num - 1]: num
);

export const getStatusFromCode = id => (
    typeof id === "number" ?
        ["Открыта", "Принята", "На выезде", "В работе", "Завершена"][id]: id
);


export const roles = ["Администратор", "Маркетинг", "Бугалтерия", "Техник", "Водитель", "Волонтер"];

const workModes = new Map([[-1, (<Danger>Отказ в обслуживании</Danger>)], [0, "Работа с клиентом"], [1, "Режим администратора"],
[2, "Режим инкассатора"], [3, (<Danger>Незаконный доступ</Danger>)], [4, (<Danger>Автомат не работает</Danger>)]]);

export const getWorkModeFromCode = (code) => (
    workModes.get(code)
);

export const getMachineRowColor = (machine) => {
    let color = 0;
    if (!machine) {
        color = 0
    } else if (new Date(machine.last_encashment_time).getTime() < new Date().getTime - 4 * 24 * 60 * 60 * 1000) {
        color = 1
    } else if ((machine.error && machine.error.toString().includes("1")) ||
               parseInt(machine.water_amount, 10) === 0 ||
               machine.temperature < 4 ||
               (machine.temperature === 0 && machine.temperature === 0) ||
               [-1, 3, 4].indexOf(machine.work_mode) !== -1 ||
               new Date(machine.last_time).getTime() < new Date().getTime() - 60 * 60 * 1000
               ) {
        color = 2
    }
    return [null, "warning", "danger"][color];
}



// WEBPACK FOOTER //
// ./src/utils/misc.js